import {
  endTabScopedAuthSession,
  getAuthToken,
  isTabScopedAuthSession,
  decodeTokenPayload,
} from "./authToken";

export function isTokenExpired(token) {
  const decoded = decodeTokenPayload(token);
  if (!decoded?.exp) return false;
  return Date.now() >= decoded.exp * 1000;
}

export function clearRestaurantSession() {
  if (isTabScopedAuthSession()) {
    endTabScopedAuthSession();
  }

  [
    "tokenLogin",
    "email",
    "userDetails",
    "restaurantId",
    "restaurantCurrency",
    "restaurantSecondaryCurrency",
    "userRole",
    "franchiseFK",
    "loginTimestamp",
    "isOwner",
    "userPermissions",
  ].forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem("adminLastActiveAt");
}

export function forceLogoutToLogin() {
  clearRestaurantSession();
  const path = window.location.pathname || "";
  const isPublicAuthPath =
    path === "/login" ||
    path.startsWith("/reset-password") ||
    path.startsWith("/accept-franchise-invite") ||
    path.startsWith("/accept-restaurant-join") ||
    path.startsWith("/activate-account") ||
    path === "/page-forgot-password" ||
    path === "/page-register";

  if (!isPublicAuthPath) {
    window.location.replace("/login");
  }
}

export function getValidAuthToken() {
  const token = getAuthToken();
  if (!token) return null;
  if (isTokenExpired(token)) {
    forceLogoutToLogin();
    return null;
  }
  return token;
}
